import { useEffect, useState } from "react"

import { isMicrositeHost } from "@/lib/is-embedded"
import { handleClose } from "@/lib/storage/embedded-thunks"
import { useAppDispatch } from "@/lib/storage/hooks"
import IconCross from "@/components/icons/cross"
import { IconButton } from "../ui/icon-button"

export function EmbedClose() {
  const dispatch = useAppDispatch()
  const [microsite, setMicrosite] = useState(false)
  useEffect(() => {
    setMicrosite(isMicrositeHost())
  }, [])
  if (microsite) return null
  return (
    <IconButton
      onClick={() => {
        void dispatch(handleClose())
      }}
      variant="primary"
      size="xs"
      icon={IconCross}
      label="Close"
      tooltip
      className="fixed top-[calc((var(--header-height)-var(--button-xs-size))/2)] right-(--embed-close-right) z-3"
    />
  )
}
